import {
  scheduleDashboardDownload as scheduleDashboardDownloadApi,
  getReportSchedulersInOrg as getReportSchedulersInOrgApi,
  updateReportScheduler as updateReportSchedulerApi,
  deleteReports as deleteReportsApi
} from '../../apiFactory/DashboardDesigner/P3fy';

// Action Types
export const GET_REPORT_SCHEDULERS_REQUEST = 'GET_REPORT_SCHEDULERS_REQUEST';
export const GET_REPORT_SCHEDULERS_SUCCESS = 'GET_REPORT_SCHEDULERS_SUCCESS';
export const GET_REPORT_SCHEDULERS_FAILURE = 'GET_REPORT_SCHEDULERS_FAILURE';

export const SCHEDULE_DASHBOARD_REQUEST = 'SCHEDULE_DASHBOARD_REQUEST';
export const SCHEDULE_DASHBOARD_SUCCESS = 'SCHEDULE_DASHBOARD_SUCCESS';
export const SCHEDULE_DASHBOARD_FAILURE = 'SCHEDULE_DASHBOARD_FAILURE';

export const UPDATE_SCHEDULER_REQUEST = 'UPDATE_SCHEDULER_REQUEST';
export const UPDATE_SCHEDULER_SUCCESS = 'UPDATE_SCHEDULER_SUCCESS';
export const UPDATE_SCHEDULER_FAILURE = 'UPDATE_SCHEDULER_FAILURE';

export const DELETE_REPORTS_REQUEST = 'DELETE_REPORTS_REQUEST';
export const DELETE_REPORTS_SUCCESS = 'DELETE_REPORTS_SUCCESS';
export const DELETE_REPORTS_FAILURE = 'DELETE_REPORTS_FAILURE';

// Action Creators
export const getReportSchedulersInOrg = (organizationId) => {
  return async (dispatch) => {
    dispatch({ type: GET_REPORT_SCHEDULERS_REQUEST });
    try {
      const schedulers = await getReportSchedulersInOrgApi(organizationId);
      dispatch({ type: GET_REPORT_SCHEDULERS_SUCCESS, payload: schedulers });
      return schedulers;
    } catch (error) {
      dispatch({ type: GET_REPORT_SCHEDULERS_FAILURE, error });
      throw error;
    }
  };
};

export const scheduleDashboardDownload = (schedulerObj, reportSchedulerObj) => {
  return async (dispatch) => {
    dispatch({ type: SCHEDULE_DASHBOARD_REQUEST });
    try {
      const result = await scheduleDashboardDownloadApi(schedulerObj, reportSchedulerObj);
      dispatch({ type: SCHEDULE_DASHBOARD_SUCCESS, payload: result });
      return result.data;
    } catch (error) {
      dispatch({ type: SCHEDULE_DASHBOARD_FAILURE, error });
      throw error;
    }
  };
};

export const updateReportScheduler = (schedulerId, id, schedulerObj, reportSchedulerObj) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_SCHEDULER_REQUEST });
    try {
      const result = await updateReportSchedulerApi(schedulerId, id, schedulerObj, reportSchedulerObj);
      dispatch({ type: UPDATE_SCHEDULER_SUCCESS, payload: result });
      return result;
    } catch (error) {
      dispatch({ type: UPDATE_SCHEDULER_FAILURE, error });
      throw error;
    }
  };
};

export const deleteReports = (report, schedulerId) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_REPORTS_REQUEST });
    try {
      const result = await deleteReportsApi(report, schedulerId);
      dispatch({ type: DELETE_REPORTS_SUCCESS, payload: { report, schedulerId } });
      return result;
    } catch (error) {
      dispatch({ type: DELETE_REPORTS_FAILURE, error });
      throw error;
    }
  };
}; 